/* vc-home-swatch.js — colour dots on home cards (vc-home-card).
   A tap shows that colour's photo on the card and points the photo link and
   the bag button at that colour, the way collection cards behave.
   Loaded with defer by the sections that render the card. */
(function () {
  'use strict';
  if (window.__vcHomeSwatch) return;
  window.__vcHomeSwatch = true;

  function pick(dot) {
    var card = dot.closest('.vch-card');
    if (!card) return;

    card.querySelectorAll('[data-vch-swatch]').forEach(function (d) {
      d.setAttribute('aria-pressed', d === dot ? 'true' : 'false');
    });

    var img = card.querySelector('.vch-card__media > img.vch-img__in');
    var src = dot.getAttribute('data-src');
    if (img && src) {
      img.removeAttribute('loading');
      img.srcset = dot.getAttribute('data-srcset') || '';
      img.src = src;
    }

    var href = dot.getAttribute('data-href');
    var link = card.querySelector('a.vch-card__media');
    if (link && href) link.setAttribute('href', href);

    /* Direct bag: add this colour. Drawer buttons (options bag, Quick add): open on this colour. */
    var id = card.querySelector('.vch-card__bag input[name="id"]');
    var btn = card.querySelector('.vch-card__bag .vc-bag__btn');
    if (id && btn) {
      id.value = dot.getAttribute('data-variant');
      btn.disabled = dot.getAttribute('data-available') !== 'true';
      var title = (link && link.getAttribute('aria-label')) || '';
      btn.setAttribute('aria-label', 'Add ' + dot.getAttribute('aria-label') + ' ' + title + ' to bag');
    }
    if (href) {
      card.querySelectorAll('quick-add [data-product-url]').forEach(function (b) {
        b.setAttribute('data-product-url', href);
      });
    }
  }

  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('[data-vch-swatch]');
    if (!dot) return;
    e.preventDefault();
    pick(dot);
  });
})();
